import React from "react";
import { SearchBar } from "./DashboardCommon";

interface TableSectionProps {
  searchValue: string;
  onSearchChange: (value: string) => void;
  onSearch: () => void;
  onKeyDown: (e: React.KeyboardEvent) => void;
  searchPlaceholder: string;
  resultsCount: number;
  children: React.ReactNode;
}

/**
 * Shared table container with search header used across kit dashboards.
 */
const TableSection: React.FC<TableSectionProps> = ({
  searchValue,
  onSearchChange,
  onSearch,
  onKeyDown,
  searchPlaceholder,
  resultsCount,
  children,
}) => {
  return (
    <div className="table-container">
      <div className="table-header">
        <SearchBar
          value={searchValue}
          onChange={onSearchChange}
          onSearch={onSearch}
          onKeyDown={onKeyDown}
          placeholder={searchPlaceholder}
        />
        <span className="results-count">{resultsCount} results found</span>
      </div>
      {children}
    </div>
  );
};

export default TableSection;

